import { type PlainDate, formatPlainDate } from "@sa-nu/shared-utils/date";

/**
 * 日程フィルターのチップ表示ラベル「チェックイン〜チェックアウト(= lastNight + 1)」。
 * 範囲未確定（どちらか null）なら null を返し、フォールバック表示は呼び出し側に委ねる。
 */
export function formatDateRangeChipLabel(
  firstNight: PlainDate | null,
  lastNight: PlainDate | null,
): string | null {
  if (firstNight === null || lastNight === null) return null;
  return `${formatPlainDate(firstNight, { format: "ja", excludeYear: true })}〜${formatPlainDate(lastNight.add({ days: 1 }), { format: "ja", excludeYear: true })}`;
}
